import React from "react";
import { Avatar, Heading, Text, VStack } from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";


const greeting = "Hello, I am Karthikeya!";
const bio1 = "A Full Stack Developer";
const bio2 = "specialised in React";


// Implement the UI for the LandingSection component according to the instructions.
// Use a combination of Avatar, Heading and VStack components.
const LandingSection = () => (
  <FullScreenSection
    justifyContent="center"
    alignItems="center"
    isDarkBackground
    backgroundColor="#0d1622"
  >
   <VStack spacing={4}>
      <Avatar
         size="2xl"
        src="karthik.jpg"
        name="Karthik"
      />
      <Heading as="h1" size="xl">
        {greeting}
      </Heading>

      <Text fontSize="lg">{bio1}</Text>
      <Text fontSize="lg">{bio2}</Text>
 </VStack>
  </FullScreenSection>
);

export default LandingSection;
